/**
 * Returns the first document number an order has of the given type.
 *
 * @param {Order} order
 * @param {DocumentTypeEnumValue} documentType
 *
 * @return {DocumentNumber|null}
 */
const getDocumentNumberFromOrder = (order, documentType) => {
    if (!order.documentNumbers?.length) {
        return null;
    }

    return order.documentNumbers.find((dn) => dn.documentType === documentType) || null;
};

module.exports = {
    getDocumentNumberFromOrder,
};
